import { fetchRecentTeamVideosCreator } from '../../../../creators/videosDashboard';
import {
  ADD_VIDEO_TO_TEAM_CARD_KEY,
  CUSTOMIZE_BRANDING_CARD_KEY,
  SHARE_VIDEO_CARD_KEY,
} from '../../../../../../shared/constants/workspaceOnboarding';

/*
  ## Team Library Onboarding Configuration

  * The `cards` array accepts `{ [CARD_KEY]: CONFIG_OBJECT }` as inputs, as well as arrays of
  `[ { [CARD_KEY1]: {...} }, { [CARD_KEY2]: {...} } ]` in case `type` is set to sequential.

  * Each card has these options available:
    > `dismissable` (Boolean)   // Allow card to be marked as complete and dismissed
    > `filter`      (Function)  // Function to define wheter the card will be displayed or not.
                                // Should return `true` for visible and `false` for hidden.
                                // This only evaluates if the card has not been dismissed yet.
    > `onComplete`  (Function)  // Callback function executed when a card is marked as complete.
    > `onDismiss`   (Function)  // Callback function executed when a card is dismissed.

  * This configuration file does not require the addition of TEAM_LIBRARY_INTRO_CARD,
  which is included to the onboarding carousel by default at utilities/getTeamLibraryCards.
*/
export const getTeamLibraryCardsConfig = ({
  isAdmin,
  userCanCustomizeSharePage,
  userHasVideosInTeamLibrary,
  hasSharedVideo,
}) => {
  return {
    cards: [
      {
        [ADD_VIDEO_TO_TEAM_CARD_KEY]: {
          dismissable: true,
          filter: () => !userHasVideosInTeamLibrary,
          onDismiss: dispatch => {
            dispatch(fetchRecentTeamVideosCreator(true));
          },
        },
      },
      {
        [SHARE_VIDEO_CARD_KEY]: {
          dismissable: true,
          filter: () => {
            return !hasSharedVideo;
          },
        },
      },
      {
        [CUSTOMIZE_BRANDING_CARD_KEY]: {
          dismissable: true,
          filter: () => isAdmin && hasSharedVideo && userCanCustomizeSharePage,
        },
      },
    ],
  };
};
